import { type Module } from "vuex";
import type { AxiosError } from "axios";
import type { DefaultApi } from "@/api";
import { Call } from "@/models/call";
import { CallAnalysis } from "@/models/call_analysis";
import { Calls } from "@/models/calls";
import type { State as RootState } from "@/stores";
export interface State {
  calls?: Calls;
}
export const module: Module<State, RootState> = {
  namespaced: true,
  actions: {
    async getLatestCall(
      { commit },
      {
        positionId,
        candidateId,
      }: {
        positionId: number;
        candidateId: number;
      },
    ) {
      const api: DefaultApi = await this.dispatch("getAuthorizedApi", null, {
        root: true,
      });
      const response = await api.getLatestCall(candidateId, positionId);
      const call = new Call(response.data);
      commit("setCall", call);
      return call;
    },
    async getCalls(
      { commit },
      {
        positionId,
        candidateId,
      }: {
        positionId: number;
        candidateId: number;
      },
    ) {
      const api: DefaultApi = await this.dispatch("getAuthorizedApi", null, {
        root: true,
      });
      const response = await api.getCalls(candidateId, positionId);
      const calls = new Calls(
        response.data.map((call: Partial<Call>) => new Call(call)),
      );
      commit("setCalls", calls);
      return calls;
    },
    async getCallAnalysis(
      {},
      {
        positionId,
        candidateId,
      }: {
        positionId: number;
        candidateId: number;
      },
    ) {
      try {
        const api: DefaultApi = await this.dispatch("getAuthorizedApi", null, {
          root: true,
        });
        const response = await api.getCallAnalysis(candidateId, positionId);
        return new CallAnalysis(response.data);
      } catch (error) {
        if ((error as AxiosError).response?.status === 404) return null;
        throw error;
      }
    },
    async postCallImmediate(
      { commit },
      {
        positionId,
        candidateId,
      }: {
        positionId: number;
        candidateId: number;
      },
    ) {
      const api: DefaultApi = await this.dispatch("getAuthorizedApi", null, {
        root: true,
      });
      const response = await api.postCallImmediate(candidateId, positionId);
      commit("statistics/invalidateStatistics", null, { root: true });
      return response;
    },
  },
  mutations: {
    setCall(state, call: Call) {
      if (state.calls === undefined) state.calls = new Calls([call]);
      else state.calls = state.calls.update(call);
    },
    setCalls(state, calls: Calls) {
      state.calls = calls;
    },
  },
};
